"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "@/models/tags.model";
export let AccountSessionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.account_session = new AccountSessionItemModel();
    this.account_pin_verify = null;
    this.account_device_permission = null;
    this.account_password_verify = null;
  }
};
AccountSessionModel.model = "account.session";
AccountSessionModel = __decorateClass([
  Annotation.ModelMeta
], AccountSessionModel);
export let AccountSessionItemModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.type = "";
    this.token = "";
    this.name = "";
    this.account = "";
    this.permissions = new TagsModel();
    this.marks = new TagsModel();
    this.need_pin_verify = false;
    this.message = "";
  }
  //
  get mark() {
    return this.marks;
  }
};
AccountSessionItemModel.model = "account.session";
AccountSessionItemModel = __decorateClass([
  Annotation.ModelMeta
], AccountSessionItemModel);
export let AccountPinModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.org_guid = "";
    this.phone = "";
    this.token = "";
  }
};
AccountPinModel.model = "pin.verify";
AccountPinModel = __decorateClass([
  Annotation.ModelMeta
], AccountPinModel);
export let DevicePermissionModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.device_code = "";
    this.device_name = "";
    this.end_tiem = "";
    this.is_next_day = false;
    this.login_ip = "";
    this.name = "";
    this.network_mac_all = [];
    this.org_guid = "";
    this.start_time = "";
    this.submit_date = "";
    this.token = "";
    this.type = "";
  }
};
DevicePermissionModel.model = "device.auth";
DevicePermissionModel = __decorateClass([
  Annotation.ModelMeta
], DevicePermissionModel);
